export interface ISearchableData {
  content: string;
  weight: number;
}

export interface ISearchResult {
  title: string;
  subTitle?: string;
  imageAddress?: string | null;
  iconName?: string;
  tag?: string;
  attachments?: ISearchResultAttachment[];
  // One of [path, externalUrl, clickHandler] must exist
  path?: string;
  externalUrl?: string;
  clickHandler?(): void;
}

export interface ISearchResults {
  searching?: boolean; // Applies to those assets that are searched asynchronously (= not in frontend side)
  count: number;
  requestedCount: number;
  smallListLimit: number;
  data: ISearchResult[];
}

export interface ISearchResultAttachment {
  title: string;
  iconName: string;
  url: string;
}

export interface ISearchable {
  searchableData: ISearchableData[];
  result: ISearchResult;
}

export enum LocallySearchableAsset {
  news = "news",
  blogpost = "blogpost",
  bulletin = "bulletin",
  material = "material",
  event = "event",
}
